<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-full md:w-5/12 lg:w-1/3 xl:w-1/4 mb-base">
        <vx-card class="h-full">
          <div slot="no-body">
            <div class="rounded-top text-center">
              <img
                :src="
                  require('@/assets/images/project/platform_user_image.png')
                "
                alt="User Pic"
                class="w-full h-full"
              />
            </div>
            <div class="py-6 list-group">
              <div class="text-center w-full p-4">
                <h4 class="mb-4">
                  {{ this.userInfo.first_name + " " + this.userInfo.last_name }}
                </h4>
                <h5 class="text-muted mb-3">
                  {{ this.userInfo.username }}
                </h5>
                <h5 class="text-muted" v-if="this.userInfo.company">
                  {{ this.userInfo.company }}
                </h5>
                <div class="flex justify-center w-full mt-6">
                  <div
                    class="px-8 py-2 vs-chip-warning bg-chip-transparent"
                    style="border-radius: 6px"
                  >
                    <span class=""
                      ><div class="h6 text-warning">
                        {{
                          userRole !== 'user'
                            ? $t("admin.roles.Manager")
                            : $t("admin.roles.User")
                        }}
                      </div></span
                    >
                  </div>
                </div>
              </div>
              <vs-divider class="" />
              <div
                class="flex cursor-pointer hover:text-warning list-group-item"
                @click="moveTo('/user-settings')"
                :class="$route.meta.tab == 1 ? 'active' : ''"
              >
                <feather-icon icon="SettingsIcon" />
                <span class="ml-4 list-group-item-text">{{
                  $t("profile.Settings")
                }}</span>
              </div>
              <div
                class="flex cursor-pointer hover:text-warning list-group-item"
                @click="moveTo('/change-password')"
                :class="$route.meta.tab == 2 ? 'active' : ''"
              >
                <feather-icon icon="LockIcon" />
                <span class="ml-4 list-group-item-text">{{
                  $t("profile.ChangePassword")
                }}</span>
              </div>
              <div
                class="flex cursor-pointer hover:text-warning list-group-item"
                @click="moveTo('/device-rentals')"
                :class="$route.meta.tab == 3 ? 'active' : ''"
              >
                <feather-icon icon="CpuIcon" />
                <span class="ml-4 list-group-item-text">{{
                  $t("profile.MyDeviceRentals")
                }}</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-full md:w-7/12 lg:w-2/3 xl:w-3/4 mb-base">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import MyDeviceRentals from './device-rentals.vue'
import AccountSettings from './account-settings.vue'
import PasswordChange from './password-change.vue'

export default {
  components: {
    'my-device-rentals': MyDeviceRentals,
    'account-settings': AccountSettings,
    'password-change': PasswordChange
  },
  data () {
    return {
      userUsername: '',
      userName: ''
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.returnUserInfo
    },
    userRole () {
      return this.$store.getters.userRole
    }
  },
  mounted () {
    this.userUsername = this.userInfo.username ? this.userInfo.username : '-'
    this.userName = this.getUserName()
    if (this.$route.path === '/profile') {
      this.$router.push('/profile/user-settings').catch(() => {})
    }
  },
  methods: {
    getUserName () {
      let user_name = ''
      user_name =
        `${this.userInfo.first_name 
        } ${ 
          this.userInfo.last_name 
        }${this.userInfo.company !== '' || this.userInfo.company !== null
          ? ` - ${  this.userInfo.company}`
          : ''}`
      return user_name
    },
    moveTo (link) {
      this.$router.push(`/profile${  link}`).catch(() => {})
    }
  }
  
}
</script>
<style lang="scss" scoped>
.list-group {
  .list-group-item {
    padding: 0.7rem 1.5rem;
    border-left: 2px solid transparent;

    .list-group-item-text {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
    }
    &.active {
      color: rgb(255, 159, 67);
      border-color: rgb(255, 159, 67);
    }
  }
}
.bg-light-primary {
  background: rgba(115, 103, 240, 0.12) !important;
}
.height-300 {
  min-height: 300px;
}
@media (min-width: 1350px) and (max-width: 1500px) {
  .xl\:w-1\/4 {
    width: 30% !important;
  }
  .xl\:w-3\/4 {
    width: 70% !important;
  }
}
@media (min-width: 1200px) and (max-width: 1349.9px) {
  .xl\:w-1\/4 {
    width: 35% !important;
  }
  .xl\:w-3\/4 {
    width: 65% !important;
    .xl\:w-3\/4 {
      width: 100% !important;
    }
  }
}

.avatar-icon {
  .feather-user {
    width: 50px;
    height: 50px;
  }
}
</style>
